import React from 'react';
import flagAt from 'assets/flags/at.png';
import flagCz from 'assets/flags/cz.png';
import flagDe from 'assets/flags/de.png';
import flagGb from 'assets/flags/gb.png';
import flagHu from 'assets/flags/hu.png';
import flagRo from 'assets/flags/ro.png';
import flagSk from 'assets/flags/sk.png';

const FLAG_SRC_BY_LOCALE: Record<string, string> = {
  'cs-CZ': flagCz,
  'sk-SK': flagSk,
  'de-AT': flagAt,
  'ro-RO': flagRo,
  'de-DE': flagDe,
  'hu-HU': flagHu,
  'en-GB': flagGb
};

type Props = {
  locale: string;
  className?: string;
};

export const EuLanguageFlag = ({ locale, className }: Props): JSX.Element => (
  <img
    src={FLAG_SRC_BY_LOCALE[locale] ?? flagGb}
    alt=""
    width={32}
    height={24}
    className={className}
    decoding="async"
    draggable={false}
  />
);
